(function () {
  if (customElements.get('divano-cart-toast')) return;

  const ADD_SOURCES = new Set([
    'product-form-component',
    'divano-bundle',
    'divano-cart-bundle',
    'divano-cart-multibuy',
    'divano-comparison-cart',
  ]);

  const TOAST_HTML = `
    <div class="divano-cart-toast__inner" role="status" aria-live="polite">
      <span class="divano-cart-toast__check" aria-hidden="true">✓</span>
      <span class="divano-cart-toast__text">Added to cart</span>
      <a class="divano-cart-toast__link" href="/cart">View cart</a>
    </div>
  `;

  function cartRoute() {
    return (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function isCartPage(cartUrl) {
    const trim = (path) => path.replace(/\/+$/, '') || '/';
    return trim(window.location.pathname) === trim(new URL(cartUrl, window.location.origin).pathname);
  }

  class DivanoCartToast extends HTMLElement {
    connectedCallback() {
      this.innerHTML = TOAST_HTML;
      const link = this.querySelector('.divano-cart-toast__link');
      if (link) {
        const cartUrl = cartRoute();
        link.setAttribute('href', cartUrl);
        link.hidden = isCartPage(cartUrl);
      }
      this._timer = null;
      this._onUpdate = this._onUpdate.bind(this);
      document.addEventListener('cart:update', this._onUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this._onUpdate);
      if (this._timer) clearTimeout(this._timer);
    }

    _onUpdate(event) {
      if (event && event.detail && event.detail.data && event.detail.data.didError) return;
      const detail = (event && event.detail) || {};
      const source = (detail.data && detail.data.source) || detail.source;
      if (!ADD_SOURCES.has(source)) return;
      this.classList.add('divano-cart-toast--visible');
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.classList.remove('divano-cart-toast--visible');
      }, 2500);
    }
  }

  customElements.define('divano-cart-toast', DivanoCartToast);

  function inject() {
    if (document.querySelector('divano-cart-toast')) return;
    const el = document.createElement('divano-cart-toast');
    el.className = 'divano-cart-toast';
    document.body.appendChild(el);
  }

  function injectStyles() {
    if (document.getElementById('divano-cart-toast-styles')) return;
    const s = document.createElement('style');
    s.id = 'divano-cart-toast-styles';
    s.textContent = `
      .divano-cart-toast {
        position: fixed;
        inset-block-end: 24px;
        inset-inline-end: 24px;
        z-index: 9999;
        max-width: calc(100vw - 48px);
        opacity: 0;
        transform: translateY(8px);
        transition: opacity 0.18s ease-out, transform 0.18s ease-out;
        pointer-events: none;
      }
      .divano-cart-toast--visible { opacity: 1; transform: translateY(0); pointer-events: auto; }
      .divano-cart-toast__inner {
        display: inline-flex; align-items: center; gap: 12px;
        padding: 12px 20px;
        background: oklch(0.20 0.01 30);
        color: oklch(0.99 0.003 30);
        font-family: var(--font-body--family, 'Manrope', system-ui, sans-serif);
        font-size: 0.875rem;
        border-radius: 4px;
        box-shadow: 0 6px 20px rgb(0 0 0 / 0.15);
      }
      .divano-cart-toast__check {
        display: inline-flex; align-items: center; justify-content: center;
        width: 18px; height: 18px;
        background: oklch(0.65 0.18 145);
        color: oklch(0.99 0.003 30);
        border-radius: 50%;
        font-size: 0.6875rem;
        font-weight: 700;
      }
      .divano-cart-toast__link {
        color: oklch(0.99 0.003 30);
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      @media (max-width: 480px) {
        .divano-cart-toast {
          inset-block-end: 16px;
          inset-inline-end: 16px;
          inset-inline-start: 16px;
          max-width: calc(100vw - 32px);
        }
        .divano-cart-toast__inner { width: 100%; justify-content: space-between; }
      }
    `;
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { injectStyles(); inject(); });
  } else {
    injectStyles();
    inject();
  }
})();
